/**
 * Image URL utility functions for admin panel
 * Mirrors the logic from Dialine-Pharmacy-V2
 */
import config from '../config';

// Derive image host from the API base (strip trailing /api), so images are
// always fetched from the same origin as the API. Override with REACT_APP_IMAGE_BASE_URL.
const IMAGE_BASE_URL =
  process.env.REACT_APP_IMAGE_BASE_URL ||
  (config.baseURL || '').replace(/\/api\/?$/, '') ||
  'http://localhost:3000';
const UPLOADS_PATH = '/uploads';

/**
 * Get the full URL for an uploaded image
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath || typeof imagePath !== 'string') return null;

  let cleanPath = imagePath.replace(/\\/g, '/');
  cleanPath = cleanPath.replace(/^uploads\//, '');

  return `${IMAGE_BASE_URL}${UPLOADS_PATH}/${cleanPath}`;
};

/**
 * Coerce an image entry to a string path
 */
const toImagePath = (image) => {
  if (typeof image === 'string') return image;
  if (image && typeof image === 'object') {
    const path = image.path ?? image.url ?? image.src;
    return typeof path === 'string' ? path : null;
  }
  return null;
};

/**
 * Get optimized image URL from an array of images
 * Priority: PICFRONT3D > PICFRONT > first available
 */
export const getOptimizedImageUrl = (images) => {
  if (!images || !Array.isArray(images) || images.length === 0) return null;

  const paths = images.map(toImagePath).filter(Boolean);
  if (paths.length === 0) return null;

  const picFront3D = paths.find((p) => p.includes('PICFRONT3D'));
  if (picFront3D) return getImageUrl(picFront3D);

  const picFront = paths.find((p) => p.includes('PICFRONT'));
  if (picFront) return getImageUrl(picFront);

  return getImageUrl(paths[0]);
};

/**
 * Normalize image array from different API response structures
 */
export const normalizeImageArray = (item, imageSize = 'F') => {
  if (!item || !item.images) return [];

  if (Array.isArray(item.images)) return item.images;

  if (item.images[imageSize] && Array.isArray(item.images[imageSize])) {
    return item.images[imageSize];
  }

  return [];
};

/**
 * Get article image URL (main entry point for product cards)
 */
export const getArticleImageUrl = (article, imageSize = 'F') => {
  if (!article || !article.images) return null;

  const images = normalizeImageArray(article, imageSize);
  if (images.length === 0) return null;

  return getOptimizedImageUrl(images);
};
